<template>
	<a :href="href" @click.prevent="scroll">
		<slot></slot>
	</a>
</template>

<script>
export default {
	name: "ScrollToLink",
	props: ["href"],
	methods: {
		scroll() {
			const element = document.querySelector(this.href);
			let offset = 56;

			if (this.href === "#propSummary") {
				offset += 105;
			}

			window.scrollTo({
				top: element.offsetTop - offset,
				left: 0,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style scoped lang="scss">
</style>
